import { Navigation as NavContainer, NavigationLink } from 'containers/Navigation';
import routes from 'routes';

const Navigation = () => (
  <NavContainer>
    <NavigationLink to={routes.root}>
      Open
    </NavigationLink>
  </NavContainer>
);

export default Navigation;
